const CardData = [
  {
    id: 0,
    path: 'audiocall',
    name: 'Аудиовызов',
    description: 'Развивает навыки восприятия речи на слух',
  },
  {
    id: 1,
    path: 'sprint',
    name: 'Спринт',
    description: 'Развивает навык быстрого переключения между языками',
  },
];

export default CardData;
